const SET_LOADDING = 'app/SET_LOADDING';

function setLoadding(data) {
    return {
        type: SET_LOADDING,
        payload: {
            items: data
        }
    }
}

export {
    SET_LOADDING,
    setLoadding
}